import React from 'react';
import InfoDialog from '../../../../../../components/dialogs/InfoDialog';
import {Trans} from 'react-i18next';
import Toggle from 'react-toggle';
import Select from 'react-select';
import {getDetectionLanguages} from '../../../../../../utils/skincareUtils';
import {deviceOptions} from '../../../config/utils/optionsUtils';
import storeUtils from '../../../../../../utils/storeUtils';
import _get from 'lodash/get';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../../../utils/smbUtils';
import useWindowWidth from '../../../../../../components/hook/useWindowWidth';
import useSkincare from '../../../../../../components/hook/useSkincare';

export default function PreviewToolBar({
  showPreview,
  setShowPreview,
  setActiveLang,
  language,
  setLanguage,
  setIsZoomed,
  device,
  setDevice,
}) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);
  const {isV2Above} = useSkincare(auth);
  const width = useWindowWidth();
  const isLandscape = _get(device, 'value') === deviceOptions[1].value;

  return (
    <div className="mb-2" style={{width: '100%'}}>
      <div className="kt-margin-r-30 kt-margin-l-30 d-flex align-items-center">
        <strong className="flex-grow-1">
          {_get(device, 'label')}
          {isLandscape && (
            <InfoDialog
              trigger={'click'}
              placement="right"
              description={
                <Trans i18nKey="p.s.uiconfiguration.preview.landscape.desc">
                  Landscape Mode is supported only on iPads with the front
                  camera positioned on the long side. Please verify your
                  device's compatibility before applying the Landscape Mode UI
                  settings.
                </Trans>
              }
            >
              <label className="cursor-help">
                &nbsp;
                <i className="fa fa-question-circle" />
              </label>
            </InfoDialog>
          )}
        </strong>
        <InfoDialog
          trigger={'click'}
          placement="auto"
          popoverMaxWidth={'400px'}
          title={
            <>
              <Trans i18nKey="p.s.u.c.preview.setting">Preview Setting</Trans>
              <InfoDialog
                trigger={'click'}
                placement="top"
                title={
                  <Trans i18nKey="p.s.c.s.preview.previewhinttitle">
                    About Preview
                  </Trans>
                }
                description={
                  <Trans i18nKey="p.s.c.s.preview.hint.desc">
                    The recommended products shown under the “With product
                    recommendation, without detection description” type are just
                    example, not real data.
                  </Trans>
                }
              >
                <i className="fa fa-question-circle cursor-pointer" />
              </InfoDialog>
              <div className="float-right">
                <i
                  className="fa fa-times cursor-pointer"
                  style={{fontSize: '20px'}}
                  onClick={() => document.body.click()}
                />
              </div>
            </>
          }
          description={
            <div className="d-flex flex-column kt-margin-t-10 kt-margin-b-10">
              <div>
                <div className="float-left kt-margin-r-20">
                  <Trans i18nKey="tutorials.steps.addskulooktour.preview.screen">
                    Preview Screen
                  </Trans>
                </div>
                <div className="float-right">
                  <Toggle
                    checked={showPreview}
                    onChange={e => setShowPreview(e.target.checked)}
                    icons={{unchecked: false}}
                  />
                </div>
              </div>
              {isV2Above && (
                <div className="kt-margin-t-10">
                  <div className="float-left kt-margin-r-20 kt-margin-t-10">
                    <Trans i18nKey="c.l.sidebar.9160.title">Device</Trans>
                  </div>
                  <div className="float-right">
                    <div
                      style={{
                        width: '180px',
                      }}
                    >
                      <Select
                        defaultValue={device}
                        options={deviceOptions.filter(
                          o => o.value !== 'mobile'
                        )}
                        value={device}
                        onChange={o => {
                          storeUtils.setUiConfigSettingDevice(
                            customerId,
                            _get(o, 'value')
                          );
                          setDevice(o);
                        }}
                        placeholder={
                          <Trans i18nKey="c.c.select.placeholder">
                            Select...
                          </Trans>
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="kt-margin-t-10">
                <div className="float-left kt-margin-r-20 kt-margin-t-10">
                  <Trans i18nKey="p.c.listrequests.language">Language</Trans>
                </div>
                <div className="float-right">
                  <div
                    style={{
                      width: '120px',
                    }}
                  >
                    <Select
                      options={getDetectionLanguages()}
                      onChange={o => {
                        setActiveLang(o.value);
                        setLanguage(o);
                      }}
                      value={language}
                      isSearchable={false}
                      isClearable={false}
                      placeholder={
                        <Trans i18nKey="c.c.select.placeholder">
                          Select...
                        </Trans>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        >
          <i className="fa fa-cog cursor-pointer" style={{fontSize: '26px'}} />
        </InfoDialog>
        {isV2Above && width >= 1024 && (
          <div>
            <img
              src={require('../../../../../../assets/icons/up-right-and-down-left-from-center-solid.svg')}
              className="cursor-pointer kt-margin-l-10"
              style={{width: '24px'}}
              alt=""
              onClick={() => setIsZoomed(prev => !prev)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
